import { Icon, IconProps } from ".";

export const Car = (props: IconProps) => {
  return (
    <Icon {...props}>
      <>
        <path d="M7.14154 16.835V15.6729H10.5688V14.5107H12.8544V13.3496H20.8559V14.5118H23.1434V15.6739L27.7145 15.6729V16.835H30V20.3246H27.7155V21.4857H26.5727V19.1635H24.2892V21.4857H23.1464V20.3246H14.0014V21.4857H12.8566V19.1635H10.5711V21.4857H9.42828V20.3246H6.00202V18.0014L6 16.8351L7.14154 16.835ZM13.9982 14.5118V15.6739H11.7106V16.8361L15.141 16.835V14.5108L13.9982 14.5118ZM19.7162 15.6729V14.5108H16.2848V16.835H22.0007V15.6729L19.7162 15.6729ZM28.8574 19.1635V18.0014H27.7146V19.1635H28.8574ZM7.1418 19.1635H8.28457V18.0014H7.1418V19.1635Z" />
        <path d="M12.8543 21.4864V22.6506H10.5688V21.4864H12.8543Z" />
        <path d="M26.5729 21.4864V22.6506H24.2884V21.4864H26.5729Z" />
      </>
    </Icon>
  );
};
